module.exports = __webpack_public_path__ + "img/fiba.2fe293fc.svg";